(ns hai.home.desktop.mini-apps.clock
  "Clock mini-app card: the current time and date, with the signed-in account's
   address underneath. The address hangs off the bottom rather than joining the
   time and date, and hovering it gives the full text when it doesn't fit."
  (:require
   [hai.datetime :as datetime]
   [hai.mini-apps.frame :as mini-apps]
   [hai.ui.components.tooltip :as tt]
   [hai.ui.rf-sugar :refer [<s]]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]
   [reagent.core :as r]))

;; ---------------------------------------------------------------------------
;; Card frame
;; ---------------------------------------------------------------------------

(o/defstyled card mini-apps/card
  {:min-width "380px"}
  [:&::before {:left "24px"}]
  [:.clock-body {:padding "32px 36px"}]
  [:.time
   {:font-size "56px" :font-weight "800" :color t/--card-forest
    :line-height "1" :letter-spacing "-0.02em"}]
  [:.date {:font-size "15px" :color t/--link-muted :margin-top "10px"}]
  ;; Zero width plus a 100% minimum keeps a long address from widening the card:
  ;; the card measures itself as if this line were empty, then the line fills
  ;; whatever width the time and date settled on and clips to one row.
  [:.account-email
   {:font-size "13px" :color t/--link-muted
    :margin-top "14px"
    :width "0" :min-width "100%"
    :white-space "nowrap" :overflow "hidden" :text-overflow "ellipsis"}])

;; ---------------------------------------------------------------------------
;; Panel
;; ---------------------------------------------------------------------------

(defn- account-email
  "The signed-in address on one clipped line, wrapped in a tooltip only while
   it is too wide to render in full."
  [address]
  (r/with-let [clipped? (r/atom false)
               email-line (r/atom nil)
               measure! (fn []
                          (when-let [element @email-line]
                            (reset! clipped?
                                    (> (.-scrollWidth element) (.-clientWidth element)))))
               _ (js/window.addEventListener "resize" measure!)]
    ;; A plain :div is the trigger — Ornament doesn't forward refs, which
    ;; Radix's trigger composition needs.
    (let [line [:div.account-email
                {:ref (fn [element]
                        (reset! email-line element)
                        (measure!))}
                address]]
      (if @clipped?
        [tt/tooltip {:content address} line]
        line))
    (finally (js/window.removeEventListener "resize" measure!))))

(defn panel []
  (r/with-let [!now (r/atom (js/Date.))
               interval (js/setInterval #(reset! !now (js/Date.)) 1000)]
    (let [now @!now
          account @(<s :auth/identity)
          address (first (:user/email account))]
      [card
       [:div.clock-body
        [:div.time (datetime/format-time now)]
        [:div.date (datetime/format-date now)]
        (when address
          [account-email address])]])
    (finally (js/clearInterval interval))))
